// Definición única de la navegación (rutas, etiqueta, icono, título de
// breadcrumb). La usa la Sidebar, el router y el breadcrumb del Navbar.
export interface NavItem {
  path: string;
  label: string;
  icon: string;
  title: string;
}

export const NAV: NavItem[] = [
  { path: '/', label: 'Inicio', icon: 'fa-house', title: 'Inicio' },
  { path: '/bodegas', label: 'Bodegas', icon: 'fa-warehouse', title: 'Bodegas' },
  { path: '/productos', label: 'Productos', icon: 'fa-box', title: 'Productos' },
  { path: '/presentaciones', label: 'Presentaciones', icon: 'fa-boxes-stacked', title: 'Presentaciones' },
  { path: '/inventario', label: 'Inventario', icon: 'fa-clipboard-list', title: 'Inventario' },
  { path: '/traslados', label: 'Traslados', icon: 'fa-right-left', title: 'Traslados' },
  { path: '/movimientos', label: 'Movimientos', icon: 'fa-clock-rotate-left', title: 'Movimientos' },
  { path: '/alertas', label: 'Alertas', icon: 'fa-bell', title: 'Alertas' },
];

export function tituloDeRuta(pathname: string): string {
  return NAV.find((n) => n.path === pathname)?.title ?? 'Inicio';
}
